/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section2_Li2Inputs */

const en_about_section2_li2 = /** @type {(inputs: About_Section2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works Offline: PureJSON is a Progressive Web App (PWA). Install it and use it without an internet connection.`)
};

const ko_about_section2_li2 = /** @type {(inputs: About_Section2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오프라인 작동: PureJSON은 프로그레시브 웹 앱(PWA)입니다. 설치하면 인터넷 연결 없이 사용할 수 있습니다.`)
};

const ja_about_section2_li2 = /** @type {(inputs: About_Section2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフライン対応：PureJSONはプログレッシブウェブアプリ（PWA）です。インストールすればインターネット接続なしで使用できます。`)
};

/**
* | output |
* | --- |
* | "Works Offline: PureJSON is a Progressive Web App (PWA). Install it and use it without an internet connection." |
*
* @param {About_Section2_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section2_li2 = /** @type {((inputs?: About_Section2_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section2_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section2_li2(inputs)
	if (locale === "ko") return ko_about_section2_li2(inputs)
	return ja_about_section2_li2(inputs)
});